import React from 'react'
import { connect } from 'react-redux'
import { getLanguage } from '../../../store/ui/reducers'
import { isOnlyCanada } from '../../../store/centers/reducers'

import imgEnWide from '../../../assets/img/banner-artik-nodes/EN/wide.jpg'
import imgEnSquared from '../../../assets/img/banner-artik-nodes/EN/squared.jpg'
import imgFrWide from '../../../assets/img/banner-artik-nodes/FR/wide.jpg'
import imgFrSquared from '../../../assets/img/banner-artik-nodes/FR/squared.jpg'

const mapStateToProps = state => {
    return {
        language: getLanguage(state),
        isOnlyCanada: isOnlyCanada(state)
    }
}

class BannerArtikNodes extends React.Component {
    render() {
        const { language, isOnlyCanada } = this.props
        const responsiveWidth = window.innerWidth <= 768

        let wideImg, squaredImg, link

        if (!isOnlyCanada) {
            // USA
            wideImg = imgEnWide
            squaredImg = imgEnSquared
            link = 'https://www.cosentino.com/usa/colors/'
        } else {
            // Canada — la URL es la misma, la imagen depende del idioma
            link = 'https://www.cosentino.com/en-ca/colours/'
            switch (language) {
                case 'fr-CA':
                    wideImg = imgFrWide
                    squaredImg = imgFrSquared
                    break
                default:
                    // en-CA y cualquier otro caso
                    wideImg = imgEnWide
                    squaredImg = imgEnSquared
                    break
            }
        }

        const image = responsiveWidth ? squaredImg : wideImg

        return (
            <div className="my-4">
                <a href={link} target="_blank" rel="noopener noreferrer">
                    <img style={{ maxWidth: '100%' }} src={image} alt="Banner Artik Nodes" />
                </a>
            </div>
        )
    }
}

export default connect(mapStateToProps, null)(BannerArtikNodes)
